import { ElementRef } from '@angular/core';
import { EmpresaService } from 'app/modules/company-view/services/empresa.service';
import { EmpresaTreeViewService } from 'app/modules/employee/services/empresa-treeView.service';
import { CompanyTreeViewService } from 'app/modules/fuse/components/tree-view/service/company-tree-view.service';
import { PageLoaderService } from 'app/modules/common/services/page-loader.service';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { CalanderFullService } from 'app/modules/Calander/services/calander-full.service';
import { DoctorService } from 'app/modules/doctor/services/doctor.service';
import * as moment from 'moment';
import { SharedService } from '../../services/shared-service';

@Component({
    selector: 'app-agenda-popup',
    templateUrl: './agenda-popup.component.html',
    styleUrls: ['./agenda-popup.component.scss'],
    standalone: false
})
export class AgendaPopupComponent implements OnInit {
  @ViewChild('medicoSelect')doctorSearchInput :ElementRef
  _medicoList :any=[];
  public disableEventClick = true;
  public disableDayClick = true;
  public selectable = true;

  public selectedStartDate: moment.Moment = null;
  public selectedEndDate: moment.Moment = null;

  public Medico: any = [];
  public HasService = false;
  public IsLoading = false;
  isValidCompany: boolean = false;
  empresaDetails: any;
  selectedCompanyId: number = 0;
  public SelectedMedico: number;
  companyName:string;
  origin:number=1;
  constructor(
    public dialogRef: MatDialogRef<AgendaPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public InputData: any,
    public sharedService: SharedService,
    public calanderFullService: CalanderFullService,
    public doctorService: DoctorService,
    private pageLoaderService: PageLoaderService,
    public companyTreeService: CompanyTreeViewService,
    private empresaTreeViewService: EmpresaTreeViewService,
    private empresaService: EmpresaService,
  ) { }

  ngOnInit(): void {
    this.LoadMedico();
    this.HasService = this.InputData.RequestParam.serviceId !== 0;
    this.selectedCompanyId=this.InputData.RequestParam.empresaId;
    if (this.HasService) {
      this.getCalendarForNextTwoMonths(this.InputData.RequestParam);
    }
    this.empresaService.GetEmpresaById(this.InputData.RequestParam.empresaId).subscribe(res=>{
     this.companyName=res.result.nombre;
    })
  }
  SearchDoctors()
  {
    const searchInput=this.doctorSearchInput.nativeElement.value ?
      this.doctorSearchInput.nativeElement.value.toLowerCase():'';

    this._medicoList =this.Medico.filter(m=>{
      if(m.viewValue!=null)
      {
        const viewValue : string=m.viewValue.toLowerCase();
        return viewValue.indexOf(searchInput) > -1;
      }
    })
  }


  async onChangeCompany(event: any): Promise<void> {
    this.getCompanyDetailsAndSetControls(event.id, false);
  } 
  getCompanyDetailsAndSetControls(
    companyId: number,
    isOnLoad: boolean
  ): void {
      if (!isOnLoad) {
          this.pageLoaderService.ShowPageLoader();
      }

      this.empresaTreeViewService.getEmpresa(companyId).subscribe(
          async (res) => {
              if (!isOnLoad) {
                  this.pageLoaderService.HidePageLoader();
              }

              if (res && res != null) {                
                  let result = res.result;
                  this.empresaDetails = result;
                  this.selectedCompanyId = result.empresaId;
                  this.isValidCompany = true;  
                  //this.refreshCalendar()
                  this.refreshCalenderWhenCompanyChange();
              }
          },
          (error) => {
              if (!isOnLoad) {
                  this.pageLoaderService.HidePageLoader();
              }

              console.error(error);
          }
      );
  }

  OnCalendarTimeSlotSelect(calendarInfo: { start: moment.Moment, end: moment.Moment }): void {
    this.selectedStartDate = calendarInfo.start;
    this.selectedEndDate = calendarInfo.end;
  }

  Cancel(): void {
    this.dialogRef.close();
  }

  ConfirmDateAndTime(): void {
    const dateOnly = this.selectedStartDate ? moment(this.selectedStartDate.format('YYYY-MM-DD')) : null;
    const time = this.selectedStartDate ? this.selectedStartDate.format('HH:mm') : null;
    if (this.InputData.RequestParam.serviceId === 0 || !this.selectedStartDate) {
      this.sharedService.ShowSnackBar('ningún servicio seleccionado');
    } else {
      this.dialogRef.close({
        Time: time,
        Date: dateOnly,
        ServiceId: this.InputData.RequestParam.serviceId,
        DoctorId: this.InputData.RequestParam.medicoId
      });
    }
  }

  sendnodeData(data: Array<any>): void {
    // send data to subscribers via observable subject
    this.sharedService.sendCalanderData(data);
  }

  getCalendarForNextTwoMonths(_selectedNode): void {
    this.selectedStartDate = null;
    this.calanderFullService.getCalendarForNextTwoMonths(_selectedNode)
      .subscribe((data: any) => {
        if (data.code === 0 || data.code === 1) {
          this.sendnodeData(data);
        }
      }, error => {
        console.error(error);
      });
  }

  LoadMedico(): void {
    this.doctorService.GetActiveDoctorsDropdown()
      .subscribe(res => {

        this.Medico = res;
        this._medicoList=res;
        const medicoId = this.InputData.RequestParam.medicoId;
        const medico = this.Medico.filter(e => e.value === medicoId);
        if (medico && medico.length > 0) {
          this.SelectedMedico = this.InputData.RequestParam.medicoId;
        }

      });
  }

  refreshCalenderWhenCompanyChange()
  {
    this.doctorService.GetServicesByCompanyAndDoctor(this.InputData.RequestParam.medicoId, this.selectedCompanyId.toString())
      .subscribe(res => {

        if (res && res.result.length > 0 && res.result[0].smehorarios.length > 0) {

          this.InputData.RequestParam.serviceId = res.result[0].smeid;
          this.HasService = true;
          this.InputData.RequestParam.empresaId=this.selectedCompanyId.toString();
          this.getCalendarForNextTwoMonths(this.InputData.RequestParam);

        } else {
          
          this.InputData.RequestParam.serviceId = 0;
          this.selectedStartDate = null;
          this.HasService = false;

        }

        this.IsLoading = false;

      }, err => {
        console.error(err);
        this.IsLoading = false;
      });
  }

  refreshCalendar(selectedOption: MatSelectChange): void {
    this._medicoList=this.Medico;
    setTimeout(() => {
      this.doctorSearchInput.nativeElement.value=null;
    }, 1000);

    this.IsLoading = true;
    this.InputData.RequestParam.medicoId = selectedOption.value;
    this.doctorService.GetServicesByCompanyAndDoctor(this.InputData.RequestParam.medicoId, this.selectedCompanyId.toString())
      .subscribe(res => {

        if (res && res.result.length > 0 && res.result[0].smehorarios.length > 0) {

          this.InputData.RequestParam.serviceId = res.result[0].smeid;
          this.HasService = true;
          this.getCalendarForNextTwoMonths(this.InputData.RequestParam);

        } else {
          
          this.InputData.RequestParam.serviceId = 0;
          this.selectedStartDate = null;
          this.HasService = false;

        }

        this.IsLoading = false;

      }, err => {
        console.error(err);
        this.IsLoading = false;
      });
  }

}
